export default __webpack_public_path__ + "static/media/QR-Phuong.dc178e7b.png";